import { ref } from 'vue'

export const user = ref({
    id: null,
    fullName: null,
    loggedIn: false
})